import React from "react";
import { Avatar, Checkbox, TableCell, TableRow, Tooltip, Typography, useTheme } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import clsx from "clsx";
import { LocationOnOutlined, PriorityHigh, Schedule } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { URLS } from "../../../apis/urls";
import { formatDate, useInternetStatusDetector } from "../../../_helpers";
import OfflineFileWrapper from "../../../components/OfflineFileWrapper";
import { MultiLabelColumn } from "../../../components/DataColumns";
import { useRowStyles } from "../../../components/CustomRowStyles";

const RepairRequestCustomRow = ({ item , handleCheckboxChange , selectedCheckBoxes, onRowClick,canShowCheckBox}) => {
    const classes = { ...useRowStyles(), ...useStyles() };
    const { t } = useTranslation();
    const isOnline = useInternetStatusDetector();
    const theme = useTheme();
    const completedWorkOrders = item.resolvers ? item.resolvers.filter(a => a.status === 4).length : 0;
    let imageURL = "";
    let attachmentId;
    const attachments = item.attachments;
    if (item.sync === 0 && attachments && attachments.length) {
        imageURL = `${window.URL.createObjectURL(new Blob([attachments[0]]))}`;
    } else if (item.sync !== 0 && attachments && attachments.length) {
        attachmentId = attachments[0].attachmentId;
        imageURL = `${URLS.GET_ATTACHMENT_THUMBNAIL}${attachments[0].attachmentId}`;
    }

    const rowClickHandler = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onRowClick(item);
    }
    const tooltipTitle = item.sync !== 0 && !isOnline ? t("repairRequest.disabled.edit") : "";

    return (
        <React.Fragment >
            <Tooltip title={tooltipTitle}>
                <TableRow onClick={rowClickHandler} className={clsx([classes.customGridRow, classes.row])} sx={{ padding: theme.spacing(0, 1), }}>
                    <TableCell>
                        <div className={classes.customSmallDeviceRowContainer} style={{ padding: 0 }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div style={{ position: "relative" }}>
                                    <OfflineFileWrapper url={imageURL} id={attachmentId}>
                                        {url => <Avatar
                                            src={url}
                                            className={clsx(classes.thumbnail, classes.avatarThumbnail, 'thumb-exception')}>
                                            {item.buildingNoExtern ? isNaN(item.buildingNoExtern) ? item.buildingNoExtern[0] : item.buildingNoExtern : ""}
                                        </Avatar>}
                                    </OfflineFileWrapper>
                                </div>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                                <div className={clsx(classes.detailContainer, classes.descriptionContainer)} style={{ maxWidth: "100%" }}>
                                    <div>
                                        <Typography className={clsx(classes.requestTitle, classes.grow)}>
                                            {`${item.number} - ${item.desc}`}
                                        </Typography>
                                    </div>
                                    <div>
                                        <Typography noWrap style={{ display: "flex" }}>
                                            {item.hasUpdate && (
                                                <>
                                                    <Tooltip title={<Typography>{t("general.actionRequired")}</Typography>}>
                                                        <PriorityHigh color="secondary" fontSize="small" size="small" />
                                                    </Tooltip>
                                                    <div className={classes.borderRight} />
                                                </>
                                            )}
                                            {item.overdue ? (
                                                <>
                                                    <Tooltip title={<Typography>{t("general.overdue")}</Typography>}>
                                                        <Schedule fontSize="small" size="small" color="error" style={{ marginRight: 5 }} />
                                                    </Tooltip>
                                                    <div className={classes.borderRight} />
                                                </>
                                            ) : item.is48HoursReminder ? (
                                                <>
                                                    <Tooltip title={<Typography>{t("general.48hours")}</Typography>}>
                                                        <Schedule fontSize="small" size="small" className={classes.warning} style={{ marginRight: 5 }} />
                                                    </Tooltip>
                                                    <div className={classes.borderRight} />
                                                </>
                                            ) : ("")}
                                            {/* CONFIRM THIS ONCHANGE LOGIC */}
                                       {canShowCheckBox && <Checkbox
                                                size="small"
                                                className={clsx(
                                                    classes.customCheckbox,
                                                    classes.noPaddingContainer
                                                )}
                                                checked={selectedCheckBoxes.includes(item.requestId)}
                                                onClick={(e) => e.stopPropagation()}
                                                onChange={() => {
                                                    handleCheckboxChange(item.requestId);
                                                }}
                                            />
                                        }
                                        </Typography> 
                                    </div>
                                </div>
                                <div className={clsx(classes.detailContainer, classes.descriptionContainer)} style={{ maxWidth: "100%" }}>
                                    <div>
                                        <Typography className={classes.requestTypeLabel}>
                                            {item.resolvers ? `${completedWorkOrders}/${item.resolvers.length}` : "0/0"}
                                        </Typography>
                                    </div>
                                    <div>
                                        <Typography
                                            className={classes.requestStatusLabel}
                                            style={{ color: item.completed ? "#2DA800" : item.overdue ? "#f00" : "#5C5C5C" }}>
                                            {t(item.status)}
                                        </Typography>
                                    </div>
                                </div>
                                <div className={clsx(classes.detailContainer, classes.descriptionContainer)} style={{ maxWidth: "100%" }}>
                                    <div className={classes.requestContainer}>
                                        <div>
                                            <Typography className={classes.requestBuildingLabel}>
                                                <div className={classes.locationIconContainer}>
                                                    <LocationOnOutlined className={classes.locationIcon} />
                                                </div>
                                                <span>
                                                    {item.location}
                                                </span>
                                            </Typography>
                                        </div>
                                        <div className={classes.labelSpacing}>
                                            <MultiLabelColumn data={item.resolvers ?  item?.resolvers.map((x) => ({name: x.name})) : item.textResolvers.map((name) => ({name: name})) } />
                                        </div>
                                    </div>
                                    <div>
                                        <Typography className={classes.requestBuildingLabel} >
                                            {formatDate(new Date(item.date))}
                                        </Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TableCell>
                </TableRow>
            </Tooltip>
        </React.Fragment>
    );
}
export default RepairRequestCustomRow;

const useStyles = makeStyles(theme => ({
    grow: {
        flexGrow: 1
    },
    labelSpacing: {
        marginLeft: 5
    },
    requestContainer: {
        display: 'flex'
    },
    descriptionContainer: {
        flexDirection: "row"
    },
    offlineIconContainer: {
        position: "absolute",
        right: 0,
        top: 0
    },
    row: {
        "& td": {
            padding: "2px",
            width: "100%",
        },
        display: "flex",
    },
    offlineIcon: {
        fontSize: 14,
        fill: theme.palette.common.white
    },
    avatarThumbnail: {
        background: theme.palette.primary.main,
        fontSize: 15,
        fontWeight: 'bold',
        borderRadius: 6,
        boxShadow: "0px 0px 3px #eee"
    },
    imageBadgeContainer1: {
        bottom: 0,
        right: 0,
        borderRadius: 0,
        borderBottomRightRadius: 6,
        borderTopLeftRadius: 6,
        fontSize: 10,
        fontWeight: "bold",
        textTransform: "capitalize"
    },
    overflowEllipse: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        "-webkit-line-clamp": 1,
        "-webkit-box-orient": "vertical",
    },
    checkboxColumn: {
        display: 'flex',
        padding: theme.spacing(.6)
    },
}));
